import Main from './routes/Main';
import "./App.css"
function App() {
  return (
     <Main />
  );
}

export default App;
